// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"431":"650767d5af2fe35a","3472":"a37ec0a91e94e3ef"}[chunkId] + ".js";
};